/* 0713-G5（0713-#28）: PDP おすすめの tol:slider:scan 発火主体。
 *
 * Dawn の <product-recommendations>（global.js ProductRecommendations）は IO 交差で
 * self-fetch → this.innerHTML 差し替えのみで、swap 完了をイベントで一切通知しない
 * （G1 ADR の G5 設計宿題）。.tol-slider ラッパーは swap 非対象の外側（tol-pdp-recommend.liquid）
 * にあり、初回サーバーレンダはトラック（.tol-pdp-recommend__grid）不在 = tol-slider.js の
 * init は early-return（data-tol-slider-init 未付与のまま）。本ファイルが swap を検知して
 * document へ tol:slider:scan を dispatch し、同一ラッパーを正規 init させる。
 *
 * - observe-then-check: MO を張る前に grid の既存を即時評価（別順序で swap が先行しても
 *   取りこぼさない・二系統レビュー一致指摘）。
 * - fetch 失敗 / レコメンド 0 件 = swap 不発生（global.js の length ガード）→ 発火なし =
 *   既存の :has() 空帯ゲートのまま fail-closed 劣化。MO 残置は無害（再 fetch 経路なし・
 *   unload で disconnect）。
 * - pageshow(persisted) でも ready-check（swap 済み＋未 init の組合せを scan で回収。
 *   基盤の pageshow は init 済みラッパーの巻き戻しのみ）。
 * - variant 切替は product-recommendations を再フェッチしない（Dawn 15.4.1 実測・
 *   relatedProducts getter はデッドコード）= 多重発火なし。scan 自体も data-init で冪等。
 */
(() => {
  /* 同一 src の <script> は複数配置で複数回実行される（フェッチは1回・実行はタグごと） */
  if (window.__tolPdpRecommendLoaded) return;
  window.__tolPdpRecommendLoaded = true;

  const GRID_SEL = '.tol-pdp-recommend__grid';
  const scan = () => document.dispatchEvent(new CustomEvent('tol:slider:scan'));

  const init = (root) => {
    root.querySelectorAll('product-recommendations.tol-pdp-recommend__rec').forEach((rec) => {
      if (rec.dataset.tolPdpRecInit) return;
      rec.dataset.tolPdpRecInit = 'true';
      /* observe-then-check: 既に swap 済みなら即 scan（MO 不要） */
      if (rec.querySelector(GRID_SEL)) {
        scan();
        return;
      }
      const mo = new MutationObserver(() => {
        if (!rec.querySelector(GRID_SEL)) return;
        mo.disconnect();
        rec._tolPdpRecMo = null;
        scan();
      });
      mo.observe(rec, { childList: true, subtree: false });
      rec._tolPdpRecMo = mo;
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('product-recommendations.tol-pdp-recommend__rec').forEach((rec) => {
      if (rec._tolPdpRecMo) {
        rec._tolPdpRecMo.disconnect();
        rec._tolPdpRecMo = null;
      }
      delete rec.dataset.tolPdpRecInit;
    });
  });
  /* bfcache 復元: swap 済み＋ラッパー未 init（履歴側で init 前に離脱等）の残りを回収 */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('product-recommendations.tol-pdp-recommend__rec').forEach((rec) => {
      if (rec.querySelector(GRID_SEL)) scan();
    });
  });
})();
